import { render, staticRenderFns } from "./ManufacturerList.vue?vue&type=template&id=0adfaaee&scoped=true&"
import script from "./ManufacturerList.vue?vue&type=script&lang=js&"
export * from "./ManufacturerList.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerList.vue?vue&type=style&index=0&id=0adfaaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adfaaee",
  null
  
)

export default component.exports